<template>
    <b-table
            :narrowed="true"
            :striped="true"
            :data="data"
    >
        <template slot-scope="props">
            <b-table-column label="ID" width="40" numeric field="id">{{props.row.id}}</b-table-column>
            <b-table-column label="Name" field="name">
                <router-link :to="{path: '/configure/devices/' + props.row.id}">
                    {{props.row.name}}
                </router-link>
            </b-table-column>
        </template>
    </b-table>
</template>

<script>
  export default {
    name: "child-device-list",
    props: ['devices'],
    computed: {
      data() {
        return this.devices ? this.devices : [];
      }
    }
  }
</script>

<style scoped>

</style>